import { IFakeNotificationsProps } from './types';
import * as React from 'react';
import './_FakeNotifications.scss'
import { CLASS_NOTIFICATIONS } from '../constants';
import { Button, Icon, Userpic } from 'kui';
import {
    FAKE_NOTIFICATION_BOARD, FAKE_NOTIFICATION_CARD,
    FAKE_NOTIFICATION_DATE,
    FAKE_NOTIFICATION_LIST,
    FAKE_NOTIFICATIONS
} from './constants';
import ReactHtmlParser from 'react-html-parser';

export function FakeNotifications ({
    onClick,
}: IFakeNotificationsProps) {
    const className = CLASS_NOTIFICATIONS + '-fake';
    const classBoard = className + '__board';
    const classCard = className + '__card';
    const classNotification = className + '__notification';
    const classNotificationHeader = classNotification + '-header';
    const classAuthor = classNotificationHeader + '-author';

    const [active, setActive] = React.useState(0);
    const ref = React.useRef(null);

    const activeItem = FAKE_NOTIFICATIONS[active];

    const DatetimeIcon = require('!!@svgr/webpack!./notification-datetime.svg').default;

    return <div
        className={className}
        onClick={(e) => {
            const target = e.target as HTMLElement;
            if (target === ref.current) return;

            const isLast = active >= FAKE_NOTIFICATIONS.length - 1;
            onClick(isLast, false, activeItem.title);
            if (!isLast) {
                setActive(active + 1);
            }
        }}
    >
        <div className={className + '__header'}>
            <div className={className + '__dot'} />
            <Icon className={classCard + '-icon'} xlink={'card'} size={16} />
            <div className={classCard + '-name'}>
                {FAKE_NOTIFICATION_CARD}
            </div>
            <Button
                variant={'icon'}
                className={className + '__done'}
                onClick={() => onClick(true, true)}
                ref={ref}
            >
                <Icon xlink={'done'} size={24} />
            </Button>
        </div>
        <div className={className + '__body'}>
            <div
                className={`
                    ${classNotificationHeader}
                    ${activeItem.isHighlight ? classNotificationHeader + '--highlight' : ''}
                `}
            >
                {activeItem.isHighlight ?
                    <DatetimeIcon className={classAuthor} />
                    : <Userpic className={classAuthor} src={'/dist/img/logo.png'}/>}
                <div className={classNotificationHeader + '-name'}>
                    {activeItem.title}
                </div>
                <Icon className={classNotificationHeader + '-icon'} xlink={activeItem.icon} size={16} />
                <div className={classNotificationHeader + '-date'}>
                    {FAKE_NOTIFICATION_DATE}
                </div>
            </div>
            <div className={classNotification + '-text'}>
                {ReactHtmlParser(activeItem.text)}
            </div>
        </div>
        <div className={className + '__footer'}>
            <div className={classBoard}>
                <Icon className={classBoard + '-icon'} xlink={'board'} size={16} />
                <div className={classBoard + '-name'}>
                    {FAKE_NOTIFICATION_BOARD}
                </div>
            </div>
            <div className={className + '__list'}>
                {FAKE_NOTIFICATION_LIST}
            </div>
        </div>
    </div>;
};
